import * as React from "react";

import { Tabs, Tab, Typography, withStyles } from "@material-ui/core";
import { observer } from "mobx-react";
import { ToolbarStore } from "modules/WBS/ToolbarStore";

const styles = (theme) => ({
  tabsRoot: {
    minHeight: "unset",
    height: "30px",
    border: "1px solid #e5e5e5",
    borderRadius: "2px",
  },
  tabsFlexContainer: {
    "& > :last-child": {
      border: "unset",
    },
  },
  tabRoot: {
    minHeight: "unset",
    height: "28px",
    minWidth: "150px",
    fontFamily: "Raleway",
    fontSize: "11px",
    fontWeight: 400,
    color: "#a1a1a1",
    borderRight: "1px solid #e5e5e5",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  tabLabelContainer: {
    padding: "0px",
  },
  tabSelected: {
    backgroundColor: "#FFFFFF",
    color: "#595959",
    fontWeight: 700,
  },
});

function TabContainer({ children }) {
  return <Typography component="div">{children}</Typography>;
}

TabContainer.propTypes = {
  children: React.Children,
};
type tab = {
  label: string;
  disabled?: boolean;
};
type IProps = {
  classes: any;
  value: number;
  tabs: Array<tab>;
  onChange: any;
};
@observer
class ToggleTabs extends React.Component<IProps> {
  render() {
    const { classes, tabs, ...props } = this.props,
      tabClasses = {
        root: classes.tabRoot,
        selected: classes.tabSelected,
        labelContainer: classes.tabLabelContainer,
      };

    return (
      <Tabs
        //indicatorColor={"none"}
        classes={{
          root: classes.tabsRoot,
          flexContainer: classes.tabsFlexContainer,
        }}
        {...props}
      >
        {tabs.map((tabProps, idx) => (
          <Tab
            key={idx}
            classes={tabClasses}
            {...tabProps}
            disabled={ToolbarStore.isProcessing === true}
          />
        ))}
      </Tabs>
    );
  }
}
export default withStyles(styles)(ToggleTabs);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/ToggleTabs.tsx